import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  verifiedMobile: {
    padding: '18px 24px',
    backgroundColor: palette.success.light,
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiSvgIcon-root': {
      marginRight: '10px',
      '& path': {
        fill: palette.success.main
      }
    }
  },
  authFieldWrapper: {
    alignItems: 'center',
    backgroundColor: palette.shades[200],
    marginTop: props => props.insideModal ? '0px' : '32px',
    display: 'flex',
    padding: '18px 24px',
    '& + &': {
      marginTop: '10px'
    }
  },
  authIcon: {
    marginRight: '10px'
  },
  success: {
    backgroundColor: palette.success.light
  }
}));
export default useStyles;